import Input from "../components/Input";

const AddressCaFields = ({ city, st, zip, handleUpdate, errors }) => {
	return (
		<div className="form-group three">
			<Input
				name="city"
				label="City"
				reqd={true}
				value={city || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>
			<Input
				name="st"
				label="Province (2-letter)"
				reqd={true}
				value={st || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>
			<Input
				name="zip"
				label="Postal Code"
				reqd={true}
				value={zip || ""}
				autocomplete="off"
				update={handleUpdate}
				errors={errors}
			/>
		</div>
	);
};

export default AddressCaFields;
